import { circIn } from 'svelte/easing';
import industrial from '$images/services_id.jpg';
import branding from '$images/services_gd.jpg';
import experience from '$images/services_ux.jpg';
import code from '$images/services_code.jpg';
import hybrid from '$images/services_hybrid.jpg';

export const components = $state({
    navOpen: false,
    navW: 0,
    headH: 0,
    footH: 0,
    mainH: 0,
    mainW: 0,
});

export const viewport = $state({
    vh: 0,
    vw: 0,
    scrollY: 0,
    scrollX: 0,
});

export const navItems = [
    {
        name: 'Home',
        path: '/',
    },
    {
        name: 'Projects',
        path: '/projects',
    },
    {
        name: 'Services',
        path: '/services/software',
    },
        {
        name: 'About',
        path: '/about',
    },
    // {
    //     name: 'Field Notes',
    //     path: '/blog',
    // },
    {
        name: 'Contact',
        path: '/contact',
    },
];

export const servicesCopy = $state([
    {
        name: 'Industrial Design',
        subheading: 'Form & Function Harmony',
        bullets: [
            'Napkin sketch to production ready; concept exploration that sells.',
            '3D modeling with mechanical insight—STEP, STL, and DFM-ready.',
            'Rapid prototyping for both aesthetic and function.',
            'Grounded in ethnographic research and real-world testing.',
        ],
        expanded: false,
        image: industrial,
    },
    // {
    //     name: 'Branding & Identity',
    //     subheading: 'Branding With Longevity',
    //     bullets: [
    //         'Bring us in',
    //         'Full identity systems: color, typography, tone',
    //         'We consider all touchpoints present and future roadmap.',
    //         'Built to flex across print, web, and product packaging',
    //     ],
    //     expanded: false,
    //     image: branding,
    // },
    {
        name: 'UX & Product Design',
        subheading: 'Human-Centered Experiences',
        bullets: [
            'Interfaces that prioritize clarity, speed, and delight.',
            'Heuristic UX evaluations, accessibility audits, user research.',
            'Continuous improvement driven by qualitative and quantiative data.',
        ],
        expanded: false,
        image: experience,
    },
    {
        name: 'MVP App Development',
        subheading: 'Complexity Simplified',
        bullets: [
            'Build scalable, performant products from day one.',
            'Full-stack development: from idea to launch-ready MVP.',
            'Tech stack consulting and architecture planning.',
            'Fast, lean cycles with post-launch support.',
        ],
        expanded: false,
        image: code,
    },
    {
        name: 'Hybrid Projects',
        subheading: 'The Blurred & In-Between',
        bullets: [
            'Define, design, test, and build—hardware, software, and services.',
            'Tailored solutions for startups, moonshots, and concept-heavy work.',
            'Empathy-driven, data-informed, uncompromising on quality.',
        ],
        expanded: false,
        image: hybrid,
    }
]);

export const servicesMini = [
		{ 
			category: 'Strategy',
			items: [
				'Advanced Development',
				'Cross-Functional Strategy',
				'Design strategy',
				'Organizational design',
			],
		},
		{ 
			category: 'Brand & Identity',
			items: [
				'Art Direction',
				'Brand design',
				'Brand strategy',
				'Visual identity',
			],
		},
		{ 
			category: 'Product Design',
			items: [
				'Advanced Development',
				'Application design',
				'Concept design',
				'Digital design',
				'Interaction design',
				'Industrial Design',
				'Exhibition Design',
				'UI/UX Design',
				'Motion Design',
				'3D Visualization',
			],
		},
		{ 
			category: 'Engineering & Production',
			items: [
				'Full stack development',
				'Front end development',
				'Mechanical prototyping',
				'Software Architecture',
				'Backend/API development',
			],
		},
];

export const sections = $state({
    total: 0,
    current: 'none',
    idAll: [],
    heights: [],
});

export const blurOut = { delay: 100, duration: 700, amount: 200, opacity: 0, easing: circIn }
